export function sanitizeHTML(input: string): string {
  const element = document.createElement("div");
  element.innerHTML = input;
  return element.textContent || element.innerText || "";
}
